import { useEffect, useState, useContext, useCallback } from "react";
import PageHeader from "../../pageheader/PageHeader";
import * as publicApi from "../../../service/publicApi";
import { HashLoader } from "react-spinners";
import { Option, Select } from "@material-tailwind/react";
import Map from "../../../component/material/map/Map";
import { CurrentUserContext } from "../../../App";
import Breadcrumb from "../breacrumb/breadcrumb";

function MapOperationRoom({ role }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [labList, setLabList] = useState([]);
  const [longitude, setLongitude] = useState(100.531792);
  const [latitude, setLatitude] = useState(13.853135);
  const [selectValueOption, setSelectValueOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nameLocationMap, setNameLocationMap] = useState(
    "88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ อ.เมือง จ.นนทบุรี 11000",
  );

  const createBackpath = "";

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: "/information" },
    {
      name: "แผนที่ห้องปฏิบัติการที่เปิดตรวจ",
      url: "/information/mapoperationRoom",
    },
  ];

  const getLaboratoryList = useCallback(async () => {
    setLoading(true);
    let res = await publicApi.getLaboratoryList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setLabList(
          res["data"]["laboratory_list"].map((item) => {
            return {
              laboratory_id: item["laboratory_id"],
              laboratory_name: item["laboratory_name"],
              current_address: item["current_address"],
              location: {
                lat: item["location"]["latitude"],
                long: item["location"]["longitude"],
              },
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  }, [setLabList, setLoading, setIsMessage]);

  useEffect(() => {
    getLaboratoryList();
  }, [getLaboratoryList]);

  const handleChange = (event) => {
    setSelectValueOption(event);
    // console.log(event)
    setLongitude(event.location.long);
    setLatitude(event.location.lat);

    setNameLocationMap(
      event.laboratory_name +
        " " +
        "ที่อยู่ " +
        event.current_address.address +
        " " +
        "หมู่ " +
        event.current_address.village_number +
        " " +
        "ซอย" +
        event.current_address.alley +
        " " +
        "ถ." +
        event.current_address.road +
        " " +
        "ต." +
        event.current_address.sub_district_name +
        " " +
        "อ." +
        event.current_address.district_name +
        " " +
        "จ." +
        event.current_address.province_name +
        " " +
        event.current_address.post_code,
    );
  };

  const onClickButton = () => {
    window.open(
      `https://maps.google.com/?q=${latitude},${longitude}`,
      "_system",
    );
  };

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <HashLoader
          loading={loading}
          style={{ display: "flex", justifyContent: "center", margin: "20px" }}
          color="#FF9768"
        />
        {/* {location.state.type ?
                <>
                    { location.state.type === 'patient' ? <NavPatient menu={'relatedinfo'} /> : null }
                    { location.state.type === 'medical' ? <MenuDoctor menuActive={'dataInformation'} /> : null }
                    { location.state.type === 'laboratory' ? <ManuOperation menuActive={'relatedinfo'} /> : null }
                    { location.state.type === 'executive' ? <MenuProvideradmin menuActive={'relatedinfo'} /> : null }
                </>
                :
                <HeadBar menu={'information'} />
            } */}
        <PageHeader
          titlename={"แผนที่ห้องปฏิบัติการที่เปิดตรวจ"}
          backpath={createBackpath}
        />

        <div className="md:w-auto md:h-[10px] w-1/3 m-auto my-10">
          <label htmlFor="laboratory_id" className="sr-only">
            เลือกห้องปฏิบัติการที่เปิดตรวจ
          </label>
          <Select
            label="เลือกห้องปฏิบัติการที่เปิดตรวจ"
            color={"orange"}
            // value={selectValueOption?.laboratory_id}
            onChange={handleChange}
            name={selectValueOption?.laboratory_name}
            id="laboratory_id"
          >
            {labList.map((i, idx) => {
              return (
                <Option
                  key={labList[idx]["laboratory_id"]}
                  value={labList[idx]}
                >
                  {i["laboratory_name"]}
                </Option>
              );
            })}
          </Select>
        </div>
        <div className="flex justify-center">
          <div style={{ width: 1000, height: 500 }}>
            <Map
              disabled={true}
              latitude={latitude}
              longitude={longitude}
              nameLab={nameLocationMap}
              onChange={(e) => {}}
            />
          </div>
        </div>
        <div className="flex justify-center">
          <div
            onClick={() => {
              onClickButton();
            }}
            className="button-theme-pg text-center py-2 px-10 my-5 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl"
          >
            ขอเส้นทาง
          </div>
        </div>
      </div>
    </>
  );
}

export default MapOperationRoom;
